import { useState } from 'react';
import { useEventListener } from '../useEventListener';
function useHover(elementRef) {
  var _a = useState(false),
    value = _a[0],
    setValue = _a[1];
  var handleMouseEnter = function () {
    return setValue(true);
  };
  var handleMouseLeave = function () {
    return setValue(false);
  };
  useEventListener('mouseenter', handleMouseEnter, elementRef);
  useEventListener('mouseleave', handleMouseLeave, elementRef);
  return value;
}
export default useHover;